<template>
    <!-- cards -->
    <v-card class="rounded-lg"
		style="height:"
		:class="{
			'mb-6 h-card-mdAndDown': $vuetify.breakpoint.mdAndDown,
			'h-card-red-mdAndDown' : (moment(date).format('dddd') !== 'Friday' && !end && !isCheckInToday) && $vuetify.breakpoint.mdAndDown,
			'box': !$vuetify.theme.dark
		}"
	>
        <v-card-text 
			class="pt-0 mt-2" 
			:class="{ 
				'holiday-day-color':  moment(date).format('dddd') === 'Friday',
				'red-background': moment(date).format('dddd') !== 'Friday' && !end && !isCheckInToday,
				'card-style-lgAndUp':  $vuetify.breakpoint.mdAndUp,
				'px-0 pb-0': $vuetify.breakpoint.mdAndDown,
				'h-card-red-mdAndDown mb-2': $vuetify.breakpoint.mdAndDown
			}"
		>
            <v-row 
				class="my-2"
				:class="{
					'd-flex flex-column': $vuetify.breakpoint.mdAndDown,
					'mb-3': $vuetify.breakpoint.mdAndDown,
					'my-2': $vuetify.breakpoint.lgAndUp
				}"
			>
				<v-col cols="4" v-if="moment(date).format('dddd') === 'Friday' && !end"></v-col>
				<v-col 
					v-if="moment(date).format('dddd') === 'Friday'" 
					cols="3" 
					class="py-0 px-1" 
				>
					<v-img src="../assets/Vectors/Happy Holiday.svg"  width="300" />
				</v-col>

				<v-col
					v-if="moment(date).format('dddd') !== 'Friday'"
					:cols="$vuetify.breakpoint.lgAndUp ? '1' : '12'"
					align-self="center"
					class="py-0 "
					:class="{
						'ps-1': $vuetify.breakpoint.lgAndUp,
						'pa-0 px-3': $vuetify.breakpoint.mdAndDown
					}"
				>
                    <div
						class=" d-flex  align-center py-2 pt-3 primary--text rounded-lg"
						:class="{ 
							'red-dark-background': moment(date).format('dddd') !== 'Friday' && !end && !isCheckInToday,
							'light-pink--text': moment(date).format('dddd') !== 'Friday' && !end && !isCheckInToday,
							'pink-light-background': !$vuetify.theme.dark,
							'white': $vuetify.theme.dark && !(moment(date).format('dddd') !== 'Friday' && !end && !isCheckInToday),
							'card-small-mdAndDown justify-center': $vuetify.breakpoint.mdAndDown,
							'card-small-lgAndUp flex-column my-1': $vuetify.breakpoint.lgAndUp
						}"
                    >
                        <span 
							class="font-weight-bold" 
							style="font-size: 23px"
							:class="{
								'mx-1': $vuetify.breakpoint.mdAndDown
							}"
						>
							{{ moment(date).format('YYYY-MM-DD').split('-')[2] }}
						</span>
                        <span>{{moment(date).format("MMM Do YY").split(' ')[0]}}</span>
                    </div>
                </v-col>

				<!-- check in / out -->
				<v-col 
					v-if="moment(date).format('dddd') !== 'Friday' && $vuetify.breakpoint.lgAndUp" 
					:cols="$vuetify.breakpoint.lgAndUp ? '3' : '6'" 
					:align-self="$vuetify.breakpoint.lgAndUp ? 'center' : 'center'"
				>
                    <v-row>
						<v-col
							v-if="moment(date).format('dddd') !== 'Friday' && !end && !isCheckInToday"
							cols="2"
							align-self="center"
							class="py-0"
                        >
                            <v-img  src="../assets/Vectors/fingerprintPink.svg" width="30" />
                        </v-col>

						<v-col
							v-else
							:cols="$vuetify.breakpoint.lgAndUp ? '2' : '1'"
							align-self="center"
							class="py-0"
                        >
                            <v-img v-if="!$vuetify.theme.dark" src="../assets/Vectors/fingerprint.svg" width="30" />
							<v-img v-else src="../assets/Vectors/whiteFingerprint.svg" width="30"  />
                        </v-col> 
                        <v-divider vertical class="me-2 color" /> 
                        <v-col :cols="$vuetify.breakpoint.lgAndUp ? 4 : 2" class="py-0" align-self="center"> 
							<v-row>
								<span 
									class="text--color fs-sm "
									:class="{ 'light-pink--text': moment(date).format('dddd') !== 'Friday' && !end && !isCheckInToday}"
								>
									Check In	
								</span>
							</v-row>
							
							<v-row>
								<span 
									class="Urbanist-font fw-9 text--color mb-0" 
									style="font-size: 15px"
									:class="{ 'light-pink--text': moment(date).format('dddd') !== 'Friday' && !end && !isCheckInToday}"
								>  
									{{ start ? moment(start).format('LT') : '-' }}
								</span>
							</v-row>
                        </v-col>

						<v-col :cols="$vuetify.breakpoint.lgAndUp ? 4 : 2" class="px-0">
							<v-row>
								<span 
									class="text--color fs-sm "
									:class="{ 'light-pink--text': moment(date).format('dddd') !== 'Friday' && !end && !isCheckInToday }"
								>
									Check out	
								</span>
							</v-row>
							<v-row>
								<span 
									class="Urbanist-font fw-9 text--color mb-0" 
									style="font-size: 15px"
									:class="{ 'light-pink--text': moment(date).format('dddd') !== 'Friday' && !end && !isCheckInToday}"
								>  
									{{ end ? moment(end).format('LT') : '-'}}
								</span>
							</v-row>
						</v-col>
					
						<!-- total hour -->
						<v-col 
							v-if="end && $vuetify.breakpoint.mdAndDown" 
							:cols="$vuetify.breakpoint.lgAndUp ? '4' : '6'" 
							align-self="center" 
							class="d-flex justify-end"
						>
							<v-row>
								<v-col
									v-if="moment(date).format('dddd') === 'Friday'"
									:cols="$vuetify.breakpoint.lgAndUp ? 3 : 1"
									align-self="center"
									class="py-0 pe-0"
								>
									<v-img
										src="../assets/Vectors/clock-nine (2).svg"
										width="25"
									/>
								</v-col>

								<v-col
									v-if="moment(date).format('dddd') !== 'Friday'"
									:cols="$vuetify.breakpoint.lgAndUp ? 3 : 1"
									align-self="center"
									class="py-0 px-1"
								>
									<v-img
										v-if="!$vuetify.theme.dark"
										src="../assets/Vectors/clock-nine (1).svg"
										width="25"
									/>
									<v-img 
										v-else
										src="../assets/Vectors/clock-nine-white.svg"
										width="25"
									/>
								</v-col>
								
								<v-divider vertical class="my-1 color" /> 

								<v-col cols="9" class="py-0" align-self="center">
									<span class="text--color"> 
										<span class="Urbanist-font me-4 fs-sm "> Total Task Hours </span>
										<br /> 
										<span class="Urbanist-font fw-9 mb-0">  
											{{ 
												(actualWorkTime).toFixed(2)
											}}
										</span> 
									</span>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
                </v-col>

				<v-row 
					v-if="$vuetify.breakpoint.mdAndDown && moment(date).format('dddd') !== 'Friday'" 
					justify="start" 
					align="center" class="justify-space-between mb-2"
				>
					<v-row justify="end" class="">
						<v-col
							v-if="moment(date).format('dddd') !== 'Friday' && !end && !isCheckInToday"
							cols="auto"
							align-self="center"
							class="py-0"
						>
							<div class="d-flex justify-end" style="width: 100%">
								<div>
									<v-img  src="../assets/Vectors/fingerprintPink.svg" width="30" />
								</div>
							</div>
						</v-col>
	
						<v-col
							v-else
							:cols="$vuetify.breakpoint.lgAndUp ? '2' : '1'"
							align-self="center"
							class="py-0"
						>	
							<div class="d-flex justify-end" style="width: 100%">
								<div>
									<v-img v-if="!$vuetify.theme.dark" src="../assets/Vectors/fingerprint.svg" width="30" />
									<v-img v-else src="../assets/Vectors/whiteFingerprint.svg" width="30"  />
								</div>
							</div>
						</v-col> 
						<v-divider vertical class="me-2 color" /> 
						<v-col cols="auto" class="py-0 px-0" align-self="center"> 
							<v-col cols="auto" class="pa-0">
								<span 
									class="text--color fs-sm "
									:class="{ 'light-pink--text': moment(date).format('dddd') !== 'Friday' && !end && !isCheckInToday}"
								>
									Check In	
								</span>
	
							</v-col>
							
							<v-col cols="12" class="pa-0">
								<span 
									class="Urbanist-font fw-9 text--color mb-0" 
									style="font-size: 15px"
									:class="{ 'light-pink--text': moment(date).format('dddd') !== 'Friday' && !end && !isCheckInToday}"
								>  
									{{ start ? moment(start).format('LT') : '-' }}
								</span>
							</v-col>
						</v-col>
	
						<v-col cols="auto" class="py-0" align-self="center">
							<v-col cols="auto" class="pa-0">
							
								<span 
									class="text--color fs-sm "
									:class="{ 'light-pink--text': moment(date).format('dddd') !== 'Friday' && !end && !isCheckInToday }"
								>
									Check out	
								</span>
							</v-col>
							
							<v-col cols="12" class="pa-0">
								<span 
									class="Urbanist-font fw-9 text--color mb-0" 
									style="font-size: 15px"
									:class="{ 'light-pink--text': moment(date).format('dddd') !== 'Friday' && !end && !isCheckInToday}"
								>  
									{{ end ? moment(end).format('LT') : '-'}}
								</span>
							</v-col>
						</v-col>
					</v-row>
					<v-spacer v-if="(moment(date).format('dddd') !== 'Friday' && !end && !isCheckInToday)" />
					<!-- total hour -->
					<v-col 
						v-if="end" 
						cols="4"
						align-self="center" 
						class="d-flex justify-end mx-3 py-0"
					>
	
						<v-col
							v-if="moment(date).format('dddd') === 'Friday'"
							cols="auto"
							align-self="center"
							class="py-0 pe-0"
						>
							<v-img
								src="../assets/Vectors/clock-nine (2).svg"
								width="25"
							/>
						</v-col>

						<v-col
							v-if="moment(date).format('dddd') !== 'Friday'"
							cols="auto"
							align-self="center"
							class="py-0 px-1 pe-2"
						>
							<v-img
								v-if="!$vuetify.theme.dark"
								src="../assets/Vectors/clock-nine (1).svg"
								width="25"
							/>
							<v-img 
								v-else
								src="../assets/Vectors/clock-nine-white.svg"
								width="25"
							/>
						</v-col>
							
						<v-divider vertical class="color" /> 

						<v-col cols="auto" class="py-0" align-self="center">
							<span class="text--color"> 
								<span class="Urbanist-font me-4 fs-sm "> Total Task Hours </span>
								<br /> 
								<span class="Urbanist-font fw-9 mb-0">  
									{{ 
										(actualWorkTime).toFixed(2)
									}}
								</span> 
							</span>
						</v-col>
					</v-col>
					<v-spacer  />
					<!-- Remaining Hours -->
					<v-col 	
						v-if="(remainingHours || additionalHours)" 
						cols="4"
						class="py-0 pe-10"
						align-self="center" 
					>
						<v-row>
							<v-col
								v-if="(remainingHours && end) || (additionalHours && end)"
								cols="auto"
								align-self="center"
								class="py-0 "
									
							>
								<v-img
									v-if="!$vuetify.theme.dark"
									src="../assets/Vectors/time-quarter-past.svg"
									width="25"
								/>

								<v-img
									v-else
									src="../assets/Vectors/time-quarter-past-white.svg"
									width="25"
								/>
							</v-col>

							<v-divider 
								v-if="remainingHours || additionalHours" 
								vertical 
								class="my-1 color" 
							/>
	
							<v-col
								v-if="remainingHours"
								cols="9"
								class="py-0"
								align-self="center"
							>
								<span 
									class="text--color" 	
									:class="{ 
										'light-pink--text': moment(date).format('dddd') !== 'Friday' && !end && !isCheckInToday
									}"
								> 
									<span class=" fs-sm "> Remaining hours </span>
									<br /> 
									<span class="time-box time-spent px-1  Urbanist-font fw-9 mb-0 rounded-pill">  
										{{(remainingHours).toFixed(2)}}
									</span> 
								</span>
							</v-col>

							<v-col
								v-if="additionalHours && end"
								cols="9"
								class="py-0 fs-sm "
								align-self="center"
							>
								<span class="text--color"> 
									<span class="me-5 green-color-text"> 
										Additional Hours  
									</span>
									<br /> 
									<span
										class="time-box time-add green-color--text px-1 font-weight-bold mb-0 rounded-pill Urbanist-font"
									>
										{{(additionalHours).toFixed(2)}}
									</span> 
								</span>
							</v-col>
						</v-row>
					</v-col>
				</v-row>

                <!-- total hour -->
                <v-col 
					v-if="end && $vuetify.breakpoint.lgAndUp" 
					:cols="$vuetify.breakpoint.lgAndUp ? '2' : '6'" 
					:align-self="$vuetify.breakpoint.lgAndUp ? 'center' : 'start'" 
					:class="{
						'px-6': $vuetify.breakpoint.mdAndDown
					}"
				>
                    <v-row>
						<v-col
							v-if="moment(date).format('dddd') === 'Friday'"
							:cols="$vuetify.breakpoint.lgAndUp ? 3 : 1"
							align-self="center"
							class="py-0 pe-0"
						>
                            <v-img
                                src="../assets/Vectors/clock-nine (2).svg"
                                width="25"
                            />
                        </v-col>

						<v-col
							v-if="moment(date).format('dddd') !== 'Friday'"
							:cols="$vuetify.breakpoint.lgAndUp ? 3 : 2"
							align-self="center"
							class="py-0 pe-0"
						>
							<v-img
								v-if="!$vuetify.theme.dark"
                                src="../assets/Vectors/clock-nine (1).svg"
                                width="25"
                            />
							<v-img 
								v-else
								src="../assets/Vectors/clock-nine-white.svg"
								width="25"
							/>
						</v-col>
						
                        <v-divider vertical class="my-1 color" /> 

                        <v-col cols="9" class="py-0" align-self="center">
                            <span class="text--color"> 
                                <span class="Urbanist-font me-4 fs-sm "> Total Task Hours </span>
                                <br /> 
                                <span class="Urbanist-font fw-9 mb-0">  
										<!-- (moment(moment(end).format('YYYY-MM-DD hh:mm:a')).diff(start, 'second', true) / 3600 ).toFixed(2) -->
									{{ 
										(actualWorkTime).toFixed(2)
									}}
                                </span> 
                            </span>
                        </v-col>
                    </v-row>
                </v-col>

                <!-- remaining hour -->
                <v-col 	
					v-if="(remainingHours || additionalHours) && $vuetify.breakpoint.lgAndUp" 
					:cols="$vuetify.breakpoint.lgAndUp ? 3 : 3" 
					align-self="center" 
					
				>
                    <v-row>
						<v-col
							v-if="(remainingHours && end) || (additionalHours && end)"
							:cols="$vuetify.breakpoint.lgAndUp ? 3 : 2"
							align-self="center"
							class="py-0 "
							:class="{
								'pe-0 ps-9': $vuetify.breakpoint.lgAndUp
							}"
						>
                            <v-img
								v-if="!$vuetify.theme.dark"
                                src="../assets/Vectors/time-quarter-past.svg"
                                width="25"
                            />

							<v-img
								v-else
                                src="../assets/Vectors/time-quarter-past-white.svg"
                                width="25"
                            />
                        </v-col>

                        <v-divider 
							v-if="remainingHours || additionalHours" 
							vertical 
							class="my-1 color" 
						/>
 
                        <v-col
							v-if="remainingHours"
							cols="9"
							class="py-0"
							align-self="center"
                        >
                            <span 
								class="text--color" 	
								:class="{ 
									'light-pink--text': moment(date).format('dddd') !== 'Friday' && !end && !isCheckInToday
								}"
							> 
                                <span class=" fs-sm "> Remaining hours </span>
                                <br /> 
                                <span class="time-box time-spent px-1  Urbanist-font fw-9 mb-0 rounded-pill">  
                                    {{(remainingHours).toFixed(2)}}
                                </span> 
                            </span>
                        </v-col>

                        <v-col
							v-if="additionalHours && end"
							cols="9"
							class="py-0 fs-sm "
							align-self="center"
                        >
                            <span class="text--color"> 
                                <span class="me-5 green-color-text"> 
									Additional Hours  
								</span>
                                <br /> 
								<span
									class="time-box time-add green-color--text px-1 font-weight-bold mb-0 rounded-pill Urbanist-font"
								>
                                    {{(additionalHours).toFixed(2)}}
                                </span> 
                            </span>
                        </v-col>
                    </v-row>
                </v-col>
				<v-spacer />
                <!-- button -->
                <v-col 
					align-self="center" 
					class="d-flex justify-end py-0 mt-0 "
					:class="{
						'px-2 flex-wrap': $vuetify.breakpoint.mdAndDown,
						'pe-0 mt-0 mr-minus-5': $vuetify.breakpoint.lgAndUp
					}"
					:cols="$vuetify.breakpoint.mdAndDown ? 12 : 'auto'"
				>
					<!-- alert didn't send task -->
					<v-card
						:elevation="0"
						v-if="moment(date).format('dddd') !== 'Friday' && !end && !isCheckInToday"
						class="card-alert red-dark-background my-2 mx-3 rounded-lg py-2"
						style="display: block"
					>
						<v-card-text class="white--text fs-sm Urbanist-font py-1 pt-3">
							<v-row>
								<v-col cols="2" class="py-0 d-flex justify-end" align-self="center" >
									<v-icon color="white" class=""> mdi-close-circle-outline  </v-icon>
								</v-col>
								<v-col class="line-h-1 pb-0 ps-0" align-self="center">
									<span class="font-weight-bold"> You Didn't Submit Your Task  </span>
									<br />
									<span class="fs-xm"> Time ran out. Make sure you send the task before 12 Am </span>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
					<!-- part time holiday -->
					<v-card v-if="partTime" :elevation="0" class="card-alert card-part-time-free my-2 mx-3 rounded-lg py-2">
						<v-card-text class="fs-sm Urbanist-font py-1">
							<v-row>
								<v-col class="py-0 d-flex flex-column align-center justify-center">
									<div class="pb-1 text-center rounded-lg rounded-t-0" style="width: 85px; height: 22px; background-color: grey">
										<span class="Urbanist-font white--text " style="font-weight: 500"> 
											Hourly leave 
										</span>
									</div>
									<div class="py-2 text--color">
										From  <span class="fw-1000"> 4:00 PM </span> To <span class="fw-1000"> 6:00 PM	 </span>
									</div>
								</v-col>
								<!-- <v-col class="">
									<span class="font-weight-bold"> You Didn't Submit Your Task  </span>
									<br />
									<span class="fs-xm"> Time ran out. Make sure you send the task before 12 Am </span> -->
								<!-- </v-col> -->
							</v-row>
						</v-card-text>
					</v-card>

					<!-- note after check in -->
					<v-card 
						v-if="isCheckInToday" 
						class="card-alert mx-2 mt-2 rounded-lg"
						:class="{
							'bg-secondary': !$vuetify.theme.dark,
							'primary-light': $vuetify.theme.dark
						}"
					>
						<v-card-text class="pt-3">
							<v-row>
								<v-col 
									cols="4" 
									class="pt-1" 
									v-if="moment().isSameOrAfter(moment().format('YYYY-MM-DD') + 'T12:00:00', 'time')"
								>
									<v-img
										src="../assets/New folder/GoodAfternoon.png"
										width="60"
									/>
								</v-col>
								<v-col v-else cols="4">
									<v-img 
										:src="photo" 
										contain class="" 
										width="90"
									/>
								</v-col>
								<v-col cols="8" align-self="center" class="px-0 line-h-1">
									<h5 class="primary--text mb-0"> Have A Great Day {{self.name}} </h5>
									<span class="Righteous-font" style="font-size: 10px; font-weight: 700">Full of Productivity and Good Vibes</span>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>

                    <v-btn 
						v-if="!(moment(date).format('dddd') === 'Friday' && !end) "
						small 
						:color="
						(moment(date).format('dddd') !== 'Friday' && end && !isCheckInToday) ? 
						'secondary' :  isCheckInToday ? 'primary' :
						(moment(date).format('dddd') === 'Friday') ? 'baby-blue-dark' : 'red-dark' 
						" 
						:height="$vuetify.breakpoint.lgAndUp ? '80' : null" 
						elevation="0" 
						class="rounded-r-lg"
						:to="{ 
							name: 'tasks', 	
							params: {
								id: workDayId
							}
						}"
						:class="{
							'ms-5 d-flex': $vuetify.breakpoint.mdAndDown
						}"
						:width="!$vuetify.breakpoint.lgAndUp ? '100%' : 'auto'"
					>
					<!-- :block="!$vuetify.breakpoint.lgAndUp" -->
                        <span 
							class="text-none Urbanist-font fw-bolder"
							:class="{ 
								'blue--text': moment(date).format('dddd') === 'Friday' && !isCheckInToday,
								'primary--text': moment(date).format('dddd') !== 'Friday' && !isCheckInToday && !$vuetify.theme.dark,
								'white--text': moment(date).format('dddd') !== 'Friday' && !isCheckInToday && $vuetify.theme.dark,
								'light-pink--text':  moment(date).format('dddd') !== 'Friday' && !end && !isCheckInToday,
								'white--text': isCheckInToday
							}"
						> 
							{{ isCheckInToday ? 'Continue' : 'View Task'}} 
						</span>
                    </v-btn>
                </v-col>   
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import { userType } from '@/helper/enum'
export default {
	props: {
		date: { type: String },
		start: { type: String },
		end: { type: String },
		totalHour: { type: Number },
		// remainingHours: { type: String },
		// additionalHours: { type: String },
		partTime: { type: String },
		isCheckInToday: { Boolean },
		workDayId: { type: String },
		actualWorkTime: { type: Number }
	},

	data () {
		return {
			userType,
			photos: [
				require('../assets/New folder/goodEvening.png'),
				require('../assets/Vectors/GoodMoring.svg'),
				require('../assets/New folder/GoodDay.png')
			]
		}
	},

	computed: {
		...mapState({
			// myData: state => state.users.myData,
			self: state => state.auth.self,
			userTypeUser: state => state.auth.self.userType
		}),
		additionalHours () {
			// this.moment(moment(this.end).format('YYYY-MM-DD hh:mm:a')).diff(this.start, 'second', true) / 3600
			if (this.actualWorkTime > 7 && this.userTypeUser === userType.Developer) {
				return (this.actualWorkTime) - 7
			} else if ((this.actualWorkTime > 8 && this.userTypeUser === userType.Administrative) || (this.actualWorkTime > 8 && this.userTypeUser === userType.Employee)) {
				return (this.actualWorkTime) - 8
			} else {
				return null
			}
		},

		remainingHours () {
			// this.moment(moment(this.end).format('YYYY-MM-DD hh:mm:a')).diff(this.start, 'second', true) / 3600
			if (this.actualWorkTime < 7 && this.userTypeUser === userType.Developer) {
				return 7 - (this.actualWorkTime)
			} else if ((this.actualWorkTime < 8 && this.userTypeUser === userType.Administrative) || (this.actualWorkTime < 8 && this.userTypeUser === userType.Employee)) {
				return 8 - (this.actualWorkTime)
			} else {
				return null
			}
		},

		photo () {
			let index = null
			if ((moment().isBefore(moment().format('YYYY-MM-DD') + 'T12:00:00'))) {
				// good morning
				console.log('2')
				index = 1
			} else if ((moment().isSameOrAfter(moment().format('YYYY-MM-DD') + 'T16:00:00'))) {
				console.log('3')
				index = 0
			}
			return this.photos[index]
		}
	},

	methods: {
		moment
	}
}
</script>

<style scoped>
.box {
	box-shadow: 3px 0px 9px -4px #25252521
}
.card-style-lgAndUp {
	width: 100%;
	height: 80px;
}
.pink-light-background {
    background-color: #FBF4DA
}
.holiday-day-color {
	background-color: #CBEFEF;
}
.time-box {
    width: max-content;
    height:  20px;
}
.time-spent {
	background-color:#ffaaaa9f ;
    color: #E81010;
}
.red-background {
	background-color: #E81010;
}
.red-dark-background {
	background-color: #a30b0b79;
	/* color: #6e0505 */
}
.time-add {
	background-color: #CBEFEF;
}

.mt-minus {
	margin-top: -3px;
}
.mr-minus {
	margin-right: -3px;
}

.mr-minus-5 {
	margin-right: -4px;
}
.mt-minus-5 {
	margin-top: -4px;
}

.font {
	font-family: 'Righteous';
	font-weight: 500;
}

.fs-sm {
	font-size: small;
}

span {
	font-family: 'Urbanist';
}
.card-alert {
	width: 320px;
	height: 65px;
}
.fs-xm {
	font-size: 9px;
}
.card-part-time-free {
	background-color: #F6F6F6;
}
.fw-1000 {
	font-weight: 1000
}
.line-h-1 {
	line-height: 1
}

.h-card-mdAndDown {
	height: 160px;
}

.h-card-red-mdAndDown  {
	height: 250px;
}
</style>
